import {Tabs} from '@chakra-ui/react'
import {useTranslate} from '@tolgee/react'
import {LuDatabase, LuHistory, LuInfo} from 'react-icons/lu'

export function TradeNameDrawerTabsList() {
  const {t} = useTranslate('common')

  return (
    <Tabs.List>
      <Tabs.Trigger value="about" data-e2e="about-trigger">
        <LuInfo />
        {t('about')}
      </Tabs.Trigger>

      <Tabs.Trigger value="batches" data-e2e="batches-trigger">
        <LuDatabase />
        {t('batches')}
      </Tabs.Trigger>

      <Tabs.Trigger value="history" data-e2e="history-trigger">
        <LuHistory />
        {t('history')}
      </Tabs.Trigger>
    </Tabs.List>
  )
}
